/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.7.1.0 (NJsonSchema v9.6.0.0) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';
import { HydrogenAppConfigService } from '../host.config.service';

export const API_BASE_URL = new InjectionToken('API_BASE_URL');

@Injectable()
export class AccountApiService {
  private http: Http;
  private baseUrl: string;
  protected jsonParseReviver: (key: string, value: any) => any = undefined;

  constructor(configSvc: HydrogenAppConfigService, @Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = configSvc.config.serviceUrl.account;
  }

  getCustomerAccountsByDealerAccountId(dealerAccountId: string): Observable<Account[]> {
    let url_ = this.baseUrl + "/api/account/GetCustomerAccountsByDealerAccountId?";
    if (dealerAccountId === undefined || dealerAccountId === null)
      throw new Error("The parameter 'dealerAccountId' must be defined and cannot be null.");
    else
      url_ += "DealerAccountId=" + encodeURIComponent("" + dealerAccountId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetCustomerAccountsByDealerAccountId(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetCustomerAccountsByDealerAccountId(response_);
        } catch (e) {
          return <Observable<Account[]>><any>Observable.throw(e);
        }
      } else
        return <Observable<Account[]>><any>Observable.throw(response_);
    });
  }

  protected processGetCustomerAccountsByDealerAccountId(response: Response): Observable<Account[]> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      if (resultData200 && resultData200.constructor === Array) {
        result200 = [];
        for (let item of resultData200)
          result200.push(Account.fromJS(item));
      }
      return Observable.of(result200);
    } else if (status === 500) {
      const _responseText = response.text();
      let result500: any = null;
      let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
      return throwException("A server error occurred.", status, _responseText, _headers, result500);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<Account[]>(<any>null);
  }

  getDealerAccounts(search: AccountSearch): Observable<Account[]> {
    let url_ = this.baseUrl + "/api/account/dealermany";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(search);

    let options_ = {
      body: content_,
      method: "post",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetDealerAccounts(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetDealerAccounts(response_);
        } catch (e) {
          return <Observable<Account[]>><any>Observable.throw(e);
        }
      } else
        return <Observable<Account[]>><any>Observable.throw(response_);
    });
  }

  protected processGetDealerAccounts(response: Response): Observable<Account[]> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      if (resultData200 && resultData200.constructor === Array) {
        result200 = [];
        for (let item of resultData200)
          result200.push(Account.fromJS(item));
      }
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<Account[]>(<any>null);
  }

  createAccount(createAccountdata: CreatAccountAPIRequest): Observable<Account> {
    let url_ = this.baseUrl + "/api/account/create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(createAccountdata);

    let options_ = {
      body: content_,
      method: "post",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processCreateAccount(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processCreateAccount(response_);
        } catch (e) {
          return <Observable<Account>><any>Observable.throw(e);
        }
      } else
        return <Observable<Account>><any>Observable.throw(response_);
    });
  }

  protected processCreateAccount(response: Response): Observable<Account> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 ? Account.fromJS(resultData200) : <any>null;
      return Observable.of(result200);
    } else if (status === 500) {
      const _responseText = response.text();
      let result500: any = null;
      let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
      return throwException("A server error occurred.", status, _responseText, _headers, result500);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<Account>(<any>null);
  }

  updateAccount(accountData: AccountAPIRequest, accountId: string): Observable<Account> {
    let url_ = this.baseUrl + "/api/account/update?";
    if (accountId !== undefined)
      url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(accountData);

    let options_ = {
      body: content_,
      method: "put",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processUpdateAccount(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processUpdateAccount(response_);
        } catch (e) {
          return <Observable<Account>><any>Observable.throw(e);
        }
      } else
        return <Observable<Account>><any>Observable.throw(response_);
    });
  }

  protected processUpdateAccount(response: Response): Observable<Account> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 ? Account.fromJS(resultData200) : <any>null;
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<Account>(<any>null);
  }

  updateAlertBatching(accountData: AccountAPIRequest, accountId: string): Observable<Account> {
    let url_ = this.baseUrl + "/api/account/UpdateAlertBatching?";
    if (accountId === undefined)
      throw new Error("The parameter 'accountId' must be defined.");
    else
      url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(accountData);

    let options_ = {
      body: content_,
      method: "put",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processUpdateAlertBatching(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processUpdateAlertBatching(response_);
        } catch (e) {
          return <Observable<Account>><any>Observable.throw(e);
        }
      } else
        return <Observable<Account>><any>Observable.throw(response_);
    });
  }

  protected processUpdateAlertBatching(response: Response): Observable<Account> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 ? Account.fromJS(resultData200) : <any>null;
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<Account>(<any>null);
  }

  updateAccountBranding(accountData: AccountAPIRequest, accountId: string): Observable<Account> {
    let url_ = this.baseUrl + "/api/account/UpdateAccountBranding?";
    if (accountId === undefined)
      throw new Error("The parameter 'accountId' must be defined.");
    else
      url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(accountData);

    let options_ = {
      body: content_,
      method: "put",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processUpdateAccountBranding(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processUpdateAccountBranding(response_);
        } catch (e) {
          return <Observable<Account>><any>Observable.throw(e);
        }
      } else
        return <Observable<Account>><any>Observable.throw(response_);
    });
  }

  protected processUpdateAccountBranding(response: Response): Observable<Account> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 ? Account.fromJS(resultData200) : <any>null;
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<Account>(<any>null);
  }

  getAccountTable(search: AccountSearch): Observable<AccountTable> {
    let url_ = this.baseUrl + "/api/account/GetAccountTable";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(search);

    let options_ = {
      body: content_,
      method: "post",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetAccountTable(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetAccountTable(response_);
        } catch (e) {
          return <Observable<AccountTable>><any>Observable.throw(e);
        }
      } else
        return <Observable<AccountTable>><any>Observable.throw(response_);
    });
  }

  protected processGetAccountTable(response: Response): Observable<AccountTable> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 ? AccountTable.fromJS(resultData200) : <any>null;
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<AccountTable>(<any>null);
  }

  getTotalAccountCount(): Observable<number> {
    let url_ = this.baseUrl + "/api/account/GetTotalAccountCount";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetTotalAccountCount(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetTotalAccountCount(response_);
        } catch (e) {
          return <Observable<number>><any>Observable.throw(e);
        }
      } else
        return <Observable<number>><any>Observable.throw(response_);
    });
  }

  protected processGetTotalAccountCount(response: Response): Observable<number> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 !== undefined ? resultData200 : <any>null;
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<number>(<any>null);
  }

  getAccounts(search: AccountSearch): Observable<Account[]> {
    let url_ = this.baseUrl + "/api/account/many";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(search);

    let options_ = {
      body: content_,
      method: "post",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetAccounts(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetAccounts(response_);
        } catch (e) {
          return <Observable<Account[]>><any>Observable.throw(e);
        }
      } else
        return <Observable<Account[]>><any>Observable.throw(response_);
    });
  }

  protected processGetAccounts(response: Response): Observable<Account[]> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      if (resultData200 && resultData200.constructor === Array) {
        result200 = [];
        for (let item of resultData200)
          result200.push(Account.fromJS(item));
      }
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<Account[]>(<any>null);
  }

  getAllDevicesForUniversalSearch(sortCriteria: string, sortDirection: string, search: string, page: number, pagesize: number): Observable<UniversalDevicesData> {
    let url_ = this.baseUrl + "/api/account/UniversalDevices?";
    if (sortCriteria !== undefined)
      url_ += "sortCriteria=" + encodeURIComponent("" + sortCriteria) + "&";
    if (sortDirection !== undefined)
      url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
    if (search !== undefined)
      url_ += "search=" + encodeURIComponent("" + search) + "&";
    if (page === null)
      throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pagesize === null)
      throw new Error("The parameter 'pagesize' cannot be null.");
    else if (pagesize !== undefined)
      url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetAllDevicesForUniversalSearch(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetAllDevicesForUniversalSearch(response_);
        } catch (e) {
          return <Observable<UniversalDevicesData>><any>Observable.throw(e);
        }
      } else
        return <Observable<UniversalDevicesData>><any>Observable.throw(response_);
    });
  }

  protected processGetAllDevicesForUniversalSearch(response: Response): Observable<UniversalDevicesData> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 ? UniversalDevicesData.fromJS(resultData200) : <any>null;
      return Observable.of(result200);
    } else if (status === 500) {
      const _responseText = response.text();
      let result500: any = null;
      let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
      return throwException("A server error occurred.", status, _responseText, _headers, result500);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<UniversalDevicesData>(<any>null);
  }

  getDevicesForAccount(id: string): Observable<DeviceList[]> {
    let url_ = this.baseUrl + "/api/account/devices/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetDevicesForAccount(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetDevicesForAccount(response_);
        } catch (e) {
          return <Observable<DeviceList[]>><any>Observable.throw(e);
        }
      } else
        return <Observable<DeviceList[]>><any>Observable.throw(response_);
    });
  }

  protected processGetDevicesForAccount(response: Response): Observable<DeviceList[]> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      if (resultData200 && resultData200.constructor === Array) {
        result200 = [];
        for (let item of resultData200)
          result200.push(DeviceList.fromJS(item));
      }
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<DeviceList[]>(<any>null);
  }

  getUnownedDevices(accountId: string, sortCriteria: string, sortDirection: string, search: string, page: number, pagesize: number): Observable<ReportUnownedDevicesData> {
    let url_ = this.baseUrl + "/api/account/UnownedDevices?";
    if (accountId === undefined)
      throw new Error("The parameter 'accountId' must be defined.");
    else
      url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
    if (sortCriteria !== undefined)
      url_ += "sortCriteria=" + encodeURIComponent("" + sortCriteria) + "&";
    if (sortDirection !== undefined)
      url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
    if (search !== undefined)
      url_ += "search=" + encodeURIComponent("" + search) + "&";
    if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pagesize !== undefined)
      url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetUnownedDevices(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetUnownedDevices(response_);
        } catch (e) {
          return <Observable<ReportUnownedDevicesData>><any>Observable.throw(e);
        }
      } else
        return <Observable<ReportUnownedDevicesData>><any>Observable.throw(response_);
    });
  }

  protected processGetUnownedDevices(response: Response): Observable<ReportUnownedDevicesData> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 ? ReportUnownedDevicesData.fromJS(resultData200) : <any>null;
      return Observable.of(result200);
    } else if (status === 500) {
      const _responseText = response.text();
      let result500: any = null;
      let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
      return throwException("A server error occurred.", status, _responseText, _headers, result500);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<ReportUnownedDevicesData>(<any>null);
  }

  getAccountById(id: string): Observable<AccountDetail> {
    let url_ = this.baseUrl + "/api/account/id/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetAccountById(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetAccountById(response_);
        } catch (e) {
          return <Observable<AccountDetail>><any>Observable.throw(e);
        }
      } else
        return <Observable<AccountDetail>><any>Observable.throw(response_);
    });
  }

  protected processGetAccountById(response: Response): Observable<AccountDetail> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 ? AccountDetail.fromJS(resultData200) : <any>null;
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<AccountDetail>(<any>null);
  }

  setAccountStatus(isActive: boolean, accountData: CreateAccountModel): Observable<boolean> {
    let url_ = this.baseUrl + "/api/account/SetAccountStatus?";
    if (isActive === undefined || isActive === null)
      throw new Error("The parameter 'isActive' must be defined and cannot be null.");
    else
      url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(accountData);

    let options_ = {
      body: content_,
      method: "put",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processSetAccountStatus(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processSetAccountStatus(response_);
        } catch (e) {
          return <Observable<boolean>><any>Observable.throw(e);
        }
      } else
        return <Observable<boolean>><any>Observable.throw(response_);
    });
  }

  protected processSetAccountStatus(response: Response): Observable<boolean> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 !== undefined ? resultData200 : <any>null;
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<boolean>(<any>null);
  }

  getCrestronAccountId(): Observable<string> {
    let url_ = this.baseUrl + "/api/account/GetCrestronAccountId";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetCrestronAccountId(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetCrestronAccountId(response_);
        } catch (e) {
          return <Observable<string>><any>Observable.throw(e);
        }
      } else
        return <Observable<string>><any>Observable.throw(response_);
    });
  }

  protected processGetCrestronAccountId(response: Response): Observable<string> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 !== undefined ? resultData200 : <any>null;
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<string>(<any>null);
  }

  checkIsAccountNameUnique(accountName: string): Observable<boolean> {
    let url_ = this.baseUrl + "/api/account/CheckIsAccountNameUnique?";
    if (accountName === undefined)
      throw new Error("The parameter 'accountName' must be defined.");
    else
      url_ += "accountName=" + encodeURIComponent("" + accountName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processCheckIsAccountNameUnique(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processCheckIsAccountNameUnique(response_);
        } catch (e) {
          return <Observable<boolean>><any>Observable.throw(e);
        }
      } else
        return <Observable<boolean>><any>Observable.throw(response_);
    });
  }

  protected processCheckIsAccountNameUnique(response: Response): Observable<boolean> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 !== undefined ? resultData200 : <any>null;
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<boolean>(<any>null);
  }

  deleteAccount(id: string): Observable<boolean> {
    let url_ = this.baseUrl + "/api/account/delete?";
    if (id === undefined)
      throw new Error("The parameter 'id' must be defined.");
    else
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = {
      method: "delete",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processDeleteAccount(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processDeleteAccount(response_);
        } catch (e) {
          return <Observable<boolean>><any>Observable.throw(e);
        }
      } else
        return <Observable<boolean>><any>Observable.throw(response_);
    });
  }

  protected processDeleteAccount(response: Response): Observable<boolean> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 !== undefined ? resultData200 : <any>null;
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<boolean>(<any>null);
  }

  unClaimDevice(id: string, activityLog: ActivityLog): Observable<boolean> {
    let url_ = this.baseUrl + "/api/account/UnClaimDevice?";
    if (id === undefined)
      throw new Error("The parameter 'id' must be defined.");
    else
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(activityLog);

    let options_ = {
      body: content_,
      method: "put",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processUnClaimDevice(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processUnClaimDevice(response_);
        } catch (e) {
          return <Observable<boolean>><any>Observable.throw(e);
        }
      } else
        return <Observable<boolean>><any>Observable.throw(response_);
    });
  }

  protected processUnClaimDevice(response: Response): Observable<boolean> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 !== undefined ? resultData200 : <any>null;
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<boolean>(<any>null);
  }

  getAccountLogs(search: AccountSearch): Observable<IndexedAccountLogsData> {
    let url_ = this.baseUrl + "/api/account/GetAccountLogs";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(search);

    let options_ = {
      body: content_,
      method: "post",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetAccountLogs(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetAccountLogs(response_);
        } catch (e) {
          return <Observable<IndexedAccountLogsData>><any>Observable.throw(e);
        }
      } else
        return <Observable<IndexedAccountLogsData>><any>Observable.throw(response_);
    });
  }

  protected processGetAccountLogs(response: Response): Observable<IndexedAccountLogsData> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 ? IndexedAccountLogsData.fromJS(resultData200) : <any>null;
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<IndexedAccountLogsData>(<any>null);
  }

  getDownloadAccountlogs(): Observable<string> {
    let url_ = this.baseUrl + "/api/account/GetDownloadAccountlogs";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetDownloadAccountlogs(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetDownloadAccountlogs(response_);
        } catch (e) {
          return <Observable<string>><any>Observable.throw(e);
        }
      } else
        return <Observable<string>><any>Observable.throw(response_);
    });
  }

  protected processGetDownloadAccountlogs(response: Response): Observable<string> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result200 = resultData200 !== undefined ? resultData200 : <any>null;
      return Observable.of(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<string>(<any>null);
  }

  getFeatures(tier: string, role: string, accountId: string): Observable<Feature[]> {
    let url_ = this.baseUrl + "/api/Feature?";
    if (tier === undefined)
      throw new Error("The parameter 'tier' must be defined.");
    else
      url_ += "Tier=" + encodeURIComponent("" + tier) + "&";
    if (role === undefined)
      throw new Error("The parameter 'role' must be defined.");
    else
      url_ += "Role=" + encodeURIComponent("" + role) + "&";
    if (accountId !== undefined)
      url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetFeatures(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetFeatures(response_);
        } catch (e) {
          return <Observable<Feature[]>><any>Observable.throw(e);
        }
      } else
        return <Observable<Feature[]>><any>Observable.throw(response_);
    });
  }

  protected processGetFeatures(response: Response): Observable<Feature[]> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      if (resultData200 && resultData200.constructor === Array) {
        result200 = [];
        for (let item of resultData200)
          result200.push(Feature.fromJS(item));
      }
      return Observable.of(result200);
    } else if (status === 500) {
      const _responseText = response.text();
      let result500: any = null;
      let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
      return throwException("A server error occurred.", status, _responseText, _headers, result500);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<Feature[]>(<any>null);
  }

  getFWVisibility(accountId: string): Observable<FWVisibility[]> {
    let url_ = this.baseUrl + "/api/releasetracks?";
    if (accountId === undefined || accountId === null)
      throw new Error("The parameter 'accountId' must be defined and cannot be null.");
    else
      url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processGetFWVisibility(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processGetFWVisibility(response_);
        } catch (e) {
          return <Observable<FWVisibility[]>><any>Observable.throw(e);
        }
      } else
        return <Observable<FWVisibility[]>><any>Observable.throw(response_);
    });
  }

  protected processGetFWVisibility(response: Response): Observable<FWVisibility[]> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      if (resultData200 && resultData200.constructor === Array) {
        result200 = [];
        for (let item of resultData200)
          result200.push(FWVisibility.fromJS(item));
      }
      return Observable.of(result200);
    } else if (status === 500) {
      const _responseText = response.text();
      let result500: any = null;
      let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
      return throwException("A server error occurred.", status, _responseText, _headers, result500);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<FWVisibility[]>(<any>null);
  }

  updateFWVisibility(accountid: string, fwVisibilityList: FWVisibility[]): Observable<FWVisibility[]> {
    let url_ = this.baseUrl + "/api/releasetracks?";
    if (accountid === undefined || accountid === null)
      throw new Error("The parameter 'accountid' must be defined and cannot be null.");
    else
      url_ += "accountid=" + encodeURIComponent("" + accountid) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(fwVisibilityList);

    let options_ = {
      body: content_,
      method: "put",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request(url_, options_).flatMap((response_) => {
      return this.processUpdateFWVisibility(response_);
    }).catch((response_: any) => {
      if (response_ instanceof Response) {
        try {
          return this.processUpdateFWVisibility(response_);
        } catch (e) {
          return <Observable<FWVisibility[]>><any>Observable.throw(e);
        }
      } else
        return <Observable<FWVisibility[]>><any>Observable.throw(response_);
    });
  }

  protected processUpdateFWVisibility(response: Response): Observable<FWVisibility[]> {
    const status = response.status;

    let _headers: any = response.headers ? response.headers.toJSON() : {};
    if (status === 200) {
      const _responseText = response.text();
      let result200: any = null;
      let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      if (resultData200 && resultData200.constructor === Array) {
        result200 = [];
        for (let item of resultData200)
          result200.push(FWVisibility.fromJS(item));
      }
      return Observable.of(result200);
    } else if (status === 500) {
      const _responseText = response.text();
      let result500: any = null;
      let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
      result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
      return throwException("A server error occurred.", status, _responseText, _headers, result500);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.text();
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Observable.of<FWVisibility[]>(<any>null);
  }
}

export class Account implements IAccount {
  id?: string;
  accountNumber?: string;
  accountName?: string;
  email?: string;
  givenName?: string;
  surname?: string;
  isCrestron: boolean;
  isActive: boolean;
  isDeleted: boolean;
  createdOn?: Date;
  modifiedOn?: Date;
  createdBy?: string;
  modifiedBy?: string;
  address?: string;
  groups?: string[];
  identityProvider?: string;
  numberAllotted: number;
  tier?: string;
  maximumUsersAllowed?: number;
  fWVisibility?: FWVisibility[];
  dealerNames?: string[];
  orders?: Order[];
  accountNotes?: string;
  expirationDate?: Date;
  expirationDateString?: string;
  isAlertsEnabled: boolean;
  isAlertsBatchingEnabled: boolean;
  accountType?: string;
  customerAccounts?: string[];
  accountBrandingInfo?: AccountBranding;

  constructor(data?: IAccount) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data["id"] !== undefined ? data["id"] : <any>null;
      this.accountNumber = data["AccountNumber"] !== undefined ? data["AccountNumber"] : <any>null;
      this.accountName = data["AccountName"] !== undefined ? data["AccountName"] : <any>null;
      this.email = data["Email"] !== undefined ? data["Email"] : <any>null;
      this.givenName = data["GivenName"] !== undefined ? data["GivenName"] : <any>null;
      this.surname = data["Surname"] !== undefined ? data["Surname"] : <any>null;
      this.isCrestron = data["IsCrestron"] !== undefined ? data["IsCrestron"] : <any>null;
      this.isActive = data["IsActive"] !== undefined ? data["IsActive"] : <any>null;
      this.isDeleted = data["IsDeleted"] !== undefined ? data["IsDeleted"] : <any>null;
      this.createdOn = data["CreatedOn"] ? new Date(data["CreatedOn"].toString()) : <any>null;
      this.modifiedOn = data["ModifiedOn"] ? new Date(data["ModifiedOn"].toString()) : <any>null;
      this.createdBy = data["CreatedBy"] !== undefined ? data["CreatedBy"] : <any>null;
      this.modifiedBy = data["ModifiedBy"] !== undefined ? data["ModifiedBy"] : <any>null;
      this.address = data["Address"] !== undefined ? data["Address"] : <any>null;
      if (data["Groups"] && data["Groups"].constructor === Array) {
        this.groups = [];
        for (let item of data["Groups"])
          this.groups.push(item);
      }
      this.identityProvider = data["identityProvider"] !== undefined ? data["identityProvider"] : <any>null;
      this.numberAllotted = data["NumberAllotted"] !== undefined ? data["NumberAllotted"] : <any>null;
      this.tier = data["Tier"] !== undefined ? data["Tier"] : <any>null;
      this.maximumUsersAllowed = data["MaximumUsersAllowed"] !== undefined ? data["MaximumUsersAllowed"] : <any>null;
      if (data["FWVisibility"] && data["FWVisibility"].constructor === Array) {
        this.fWVisibility = [];
        for (let item of data["FWVisibility"])
          this.fWVisibility.push(FWVisibility.fromJS(item));
      }
      if (data["DealerNames"] && data["DealerNames"].constructor === Array) {
        this.dealerNames = [];
        for (let item of data["DealerNames"])
          this.dealerNames.push(item);
      }
      if (data["Orders"] && data["Orders"].constructor === Array) {
        this.orders = [];
        for (let item of data["Orders"])
          this.orders.push(Order.fromJS(item));
      }
      this.accountNotes = data["AccountNotes"] !== undefined ? data["AccountNotes"] : <any>null;
      this.expirationDate = data["ExpirationDate"] ? new Date(data["ExpirationDate"].toString()) : <any>null;
      this.expirationDateString = data["ExpirationDateString"] !== undefined ? data["ExpirationDateString"] : <any>null;
      this.isAlertsEnabled = data["IsAlertsEnabled"] !== undefined ? data["IsAlertsEnabled"] : <any>null;
      this.isAlertsBatchingEnabled = data["IsAlertsBatchingEnabled"] !== undefined ? data["IsAlertsBatchingEnabled"] : <any>null;
      this.accountType = data["AccountType"] !== undefined ? data["AccountType"] : <any>null;
      if (data["CustomerAccounts"] && data["CustomerAccounts"].constructor === Array) {
        this.customerAccounts = [];
        for (let item of data["CustomerAccounts"])
          this.customerAccounts.push(item);
      }
      this.accountBrandingInfo = data["AccountBrandingInfo"] ? AccountBranding.fromJS(data["AccountBrandingInfo"]) : <any>null;
    }
  }

  static fromJS(data: any): Account {
    let result = new Account();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["AccountNumber"] = this.accountNumber !== undefined ? this.accountNumber : <any>null;
    data["AccountName"] = this.accountName !== undefined ? this.accountName : <any>null;
    data["Email"] = this.email !== undefined ? this.email : <any>null;
    data["GivenName"] = this.givenName !== undefined ? this.givenName : <any>null;
    data["Surname"] = this.surname !== undefined ? this.surname : <any>null;
    data["IsCrestron"] = this.isCrestron !== undefined ? this.isCrestron : <any>null;
    data["IsActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    data["IsDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
    data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>null;
    data["CreatedBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["ModifiedBy"] = this.modifiedBy !== undefined ? this.modifiedBy : <any>null;
    data["Address"] = this.address !== undefined ? this.address : <any>null;
    if (this.groups && this.groups.constructor === Array) {
      data["Groups"] = [];
      for (let item of this.groups)
        data["Groups"].push(item);
    }
    data["identityProvider"] = this.identityProvider !== undefined ? this.identityProvider : <any>null;
    data["NumberAllotted"] = this.numberAllotted !== undefined ? this.numberAllotted : <any>null;
    data["Tier"] = this.tier !== undefined ? this.tier : <any>null;
    data["MaximumUsersAllowed"] = this.maximumUsersAllowed !== undefined ? this.maximumUsersAllowed : <any>null;
    if (this.fWVisibility && this.fWVisibility.constructor === Array) {
      data["FWVisibility"] = [];
      for (let item of this.fWVisibility)
        data["FWVisibility"].push(item.toJSON());
    }
    if (this.dealerNames && this.dealerNames.constructor === Array) {
      data["DealerNames"] = [];
      for (let item of this.dealerNames)
        data["DealerNames"].push(item);
    }
    if (this.orders && this.orders.constructor === Array) {
      data["Orders"] = [];
      for (let item of this.orders)
        data["Orders"].push(item.toJSON());
    }
    data["AccountNotes"] = this.accountNotes !== undefined ? this.accountNotes : <any>null;
    data["ExpirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>null;
    data["ExpirationDateString"] = this.expirationDateString !== undefined ? this.expirationDateString : <any>null;
    data["IsAlertsEnabled"] = this.isAlertsEnabled !== undefined ? this.isAlertsEnabled : <any>null;
    data["IsAlertsBatchingEnabled"] = this.isAlertsBatchingEnabled !== undefined ? this.isAlertsBatchingEnabled : <any>null;
    data["AccountType"] = this.accountType !== undefined ? this.accountType : <any>null;
    if (this.customerAccounts && this.customerAccounts.constructor === Array) {
      data["CustomerAccounts"] = [];
      for (let item of this.customerAccounts)
        data["CustomerAccounts"].push(item);
    }
    data["AccountBrandingInfo"] = this.accountBrandingInfo ? this.accountBrandingInfo.toJSON() : <any>null;
    return data;
  }
}

export interface IAccount {
  id?: string;
  accountNumber?: string;
  accountName?: string;
  email?: string;
  givenName?: string;
  surname?: string;
  isCrestron: boolean;
  isActive: boolean;
  isDeleted: boolean;
  createdOn?: Date;
  modifiedOn?: Date;
  createdBy?: string;
  modifiedBy?: string;
  address?: string;
  groups?: string[];
  identityProvider?: string;
  numberAllotted: number;
  tier?: string;
  maximumUsersAllowed?: number;
  fWVisibility?: FWVisibility[];
  dealerNames?: string[];
  orders?: Order[];
  accountNotes?: string;
  expirationDate?: Date;
  expirationDateString?: string;
  isAlertsEnabled: boolean;
  isAlertsBatchingEnabled: boolean;
  accountType?: string;
  customerAccounts?: string[];
  accountBrandingInfo?: AccountBranding;
}

export class FWVisibility implements IFWVisibility {
  model?: string;
  isPreRelease: boolean;

  constructor(data?: IFWVisibility) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.model = data["Model"] !== undefined ? data["Model"] : <any>null;
      this.isPreRelease = data["IsPreRelease"] !== undefined ? data["IsPreRelease"] : <any>null;
    }
  }

  static fromJS(data: any): FWVisibility {
    let result = new FWVisibility();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["Model"] = this.model !== undefined ? this.model : <any>null;
    data["IsPreRelease"] = this.isPreRelease !== undefined ? this.isPreRelease : <any>null;
    return data;
  }
}

export interface IFWVisibility {
  model?: string;
  isPreRelease: boolean;
}

export class Order implements IOrder {
  orderNumber?: string;
  orderNotes?: string;
  orderDate: Date;

  constructor(data?: IOrder) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.orderNumber = data["OrderNumber"] !== undefined ? data["OrderNumber"] : <any>null;
      this.orderNotes = data["OrderNotes"] !== undefined ? data["OrderNotes"] : <any>null;
      this.orderDate = data["OrderDate"] ? new Date(data["OrderDate"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): Order {
    let result = new Order();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["OrderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
    data["OrderNotes"] = this.orderNotes !== undefined ? this.orderNotes : <any>null;
    data["OrderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>null;
    return data;
  }
}

export interface IOrder {
  orderNumber?: string;
  orderNotes?: string;
  orderDate: Date;
}

export class AccountBranding implements IAccountBranding {
  imagePath?: string;
  imageSize?: string;
  imageFormat?: string;

  constructor(data?: IAccountBranding) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.imagePath = data["ImagePath"] !== undefined ? data["ImagePath"] : <any>null;
      this.imageSize = data["ImageSize"] !== undefined ? data["ImageSize"] : <any>null;
      this.imageFormat = data["ImageFormat"] !== undefined ? data["ImageFormat"] : <any>null;
    }
  }

  static fromJS(data: any): AccountBranding {
    let result = new AccountBranding();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["ImagePath"] = this.imagePath !== undefined ? this.imagePath : <any>null;
    data["ImageSize"] = this.imageSize !== undefined ? this.imageSize : <any>null;
    data["ImageFormat"] = this.imageFormat !== undefined ? this.imageFormat : <any>null;
    return data;
  }
}

export interface IAccountBranding {
  imagePath?: string;
  imageSize?: string;
  imageFormat?: string;
}

export class CustomError implements ICustomError {
  severity: SeverityEnum;
  statusCode: HttpStatusCode;
  correlationId?: string;
  message?: string;
  exceptionType?: string;

  constructor(data?: ICustomError) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.severity = data["Severity"] !== undefined ? data["Severity"] : <any>null;
      this.statusCode = data["StatusCode"] !== undefined ? data["StatusCode"] : <any>null;
      this.correlationId = data["CorrelationId"] !== undefined ? data["CorrelationId"] : <any>null;
      this.message = data["Message"] !== undefined ? data["Message"] : <any>null;
      this.exceptionType = data["ExceptionType"] !== undefined ? data["ExceptionType"] : <any>null;
    }
  }

  static fromJS(data: any): CustomError {
    let result = new CustomError();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["Severity"] = this.severity !== undefined ? this.severity : <any>null;
    data["StatusCode"] = this.statusCode !== undefined ? this.statusCode : <any>null;
    data["CorrelationId"] = this.correlationId !== undefined ? this.correlationId : <any>null;
    data["Message"] = this.message !== undefined ? this.message : <any>null;
    data["ExceptionType"] = this.exceptionType !== undefined ? this.exceptionType : <any>null;
    return data;
  }
}

export interface ICustomError {
  severity: SeverityEnum;
  statusCode: HttpStatusCode;
  correlationId?: string;
  message?: string;
  exceptionType?: string;
}

export enum SeverityEnum {
  None = 0,
  Warning = 1,
  Error = 2,
  Exception = 3,
}

export enum HttpStatusCode {
  Continue = 100,
  SwitchingProtocols = 101,
  OK = 200,
  Created = 201,
  Accepted = 202,
  NonAuthoritativeInformation = 203,
  NoContent = 204,
  ResetContent = 205,
  PartialContent = 206,
  MultipleChoices = 300,
  Ambiguous = 300,
  MovedPermanently = 301,
  Moved = 301,
  Found = 302,
  Redirect = 302,
  SeeOther = 303,
  RedirectMethod = 303,
  NotModified = 304,
  UseProxy = 305,
  Unused = 306,
  TemporaryRedirect = 307,
  RedirectKeepVerb = 307,
  BadRequest = 400,
  Unauthorized = 401,
  PaymentRequired = 402,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  NotAcceptable = 406,
  ProxyAuthenticationRequired = 407,
  RequestTimeout = 408,
  Conflict = 409,
  Gone = 410,
  LengthRequired = 411,
  PreconditionFailed = 412,
  RequestEntityTooLarge = 413,
  RequestUriTooLong = 414,
  UnsupportedMediaType = 415,
  RequestedRangeNotSatisfiable = 416,
  ExpectationFailed = 417,
  UpgradeRequired = 426,
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504,
  HttpVersionNotSupported = 505,
}

export class AccountSearch implements IAccountSearch {
  searchText?: string;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  pageSize?: number;

  constructor(data?: IAccountSearch) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.searchText = data["SearchText"] !== undefined ? data["SearchText"] : <any>null;
      this.sortBy = data["SortBy"] !== undefined ? data["SortBy"] : <any>null;
      this.sortDirection = data["SortDirection"] !== undefined ? data["SortDirection"] : <any>null;
      this.page = data["Page"] !== undefined ? data["Page"] : <any>null;
      this.pageSize = data["PageSize"] !== undefined ? data["PageSize"] : <any>null;
    }
  }

  static fromJS(data: any): AccountSearch {
    let result = new AccountSearch();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["SearchText"] = this.searchText !== undefined ? this.searchText : <any>null;
    data["SortBy"] = this.sortBy !== undefined ? this.sortBy : <any>null;
    data["SortDirection"] = this.sortDirection !== undefined ? this.sortDirection : <any>null;
    data["Page"] = this.page !== undefined ? this.page : <any>null;
    data["PageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
    return data;
  }
}

export interface IAccountSearch {
  searchText?: string;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  pageSize?: number;
}

export class CreatAccountAPIRequest implements ICreatAccountAPIRequest {
  createAccountModel?: CreateAccountModel;
  activitylogs?: ActivityLog[];
  dealerAccountIds?: string[];

  constructor(data?: ICreatAccountAPIRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.createAccountModel = data["createAccountModel"] ? CreateAccountModel.fromJS(data["createAccountModel"]) : <any>null;
      if (data["activitylogs"] && data["activitylogs"].constructor === Array) {
        this.activitylogs = [];
        for (let item of data["activitylogs"])
          this.activitylogs.push(ActivityLog.fromJS(item));
      }
      if (data["dealerAccountIds"] && data["dealerAccountIds"].constructor === Array) {
        this.dealerAccountIds = [];
        for (let item of data["dealerAccountIds"])
          this.dealerAccountIds.push(item);
      }
    }
  }

  static fromJS(data: any): CreatAccountAPIRequest {
    let result = new CreatAccountAPIRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["createAccountModel"] = this.createAccountModel ? this.createAccountModel.toJSON() : <any>null;
    if (this.activitylogs && this.activitylogs.constructor === Array) {
      data["activitylogs"] = [];
      for (let item of this.activitylogs)
        data["activitylogs"].push(item.toJSON());
    }
    if (this.dealerAccountIds && this.dealerAccountIds.constructor === Array) {
      data["dealerAccountIds"] = [];
      for (let item of this.dealerAccountIds)
        data["dealerAccountIds"].push(item);
    }
    return data;
  }
}

export interface ICreatAccountAPIRequest {
  createAccountModel?: CreateAccountModel;
  activitylogs?: ActivityLog[];
  dealerAccountIds?: string[];
}

export class CreateAccountModel implements ICreateAccountModel {
  accountInfo?: Account;
  globalAdmin?: HydrogenUser;

  constructor(data?: ICreateAccountModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.accountInfo = data["AccountInfo"] ? Account.fromJS(data["AccountInfo"]) : <any>null;
      this.globalAdmin = data["GlobalAdmin"] ? HydrogenUser.fromJS(data["GlobalAdmin"]) : <any>null;
    }
  }

  static fromJS(data: any): CreateAccountModel {
    let result = new CreateAccountModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["AccountInfo"] = this.accountInfo ? this.accountInfo.toJSON() : <any>null;
    data["GlobalAdmin"] = this.globalAdmin ? this.globalAdmin.toJSON() : <any>null;
    return data;
  }
}

export interface ICreateAccountModel {
  accountInfo?: Account;
  globalAdmin?: HydrogenUser;
}

export class HydrogenUser implements IHydrogenUser {
  id?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  userType: UserTypeEnum;
  userPhone?: string;
  isActive: boolean;
  isDeleted: boolean;
  createdOn: Date;
  modifiedOn: Date;
  lastLogin: Date;
  createdBy?: string;
  modifiedBy?: string;
  role?: string;
  accountId: string;
  tenantVerifiedDomainName?: string;
  userName?: string;
  alertEmail?: string;
  canReceiveAlertEmail?: boolean;
  alertMobilePhone?: string;
  alertMobilePhoneCountryCode?: string;
  canReceiveAlertSMS?: boolean;
  showWhatsNew?: boolean;
  newFeatureAvailable?: boolean;
  dealerUser?: boolean;
  customerAccounts?: CustomerAccountAccess[];

  constructor(data?: IHydrogenUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data["id"] !== undefined ? data["id"] : <any>null;
      this.firstName = data["FirstName"] !== undefined ? data["FirstName"] : <any>null;
      this.middleName = data["MiddleName"] !== undefined ? data["MiddleName"] : <any>null;
      this.lastName = data["LastName"] !== undefined ? data["LastName"] : <any>null;
      this.email = data["Email"] !== undefined ? data["Email"] : <any>null;
      this.userType = data["UserType"] !== undefined ? data["UserType"] : <any>null;
      this.userPhone = data["UserPhone"] !== undefined ? data["UserPhone"] : <any>null;
      this.isActive = data["IsActive"] !== undefined ? data["IsActive"] : <any>null;
      this.isDeleted = data["IsDeleted"] !== undefined ? data["IsDeleted"] : <any>null;
      this.createdOn = data["CreatedOn"] ? new Date(data["CreatedOn"].toString()) : <any>null;
      this.modifiedOn = data["ModifiedOn"] ? new Date(data["ModifiedOn"].toString()) : <any>null;
      this.lastLogin = data["LastLogin"] ? new Date(data["LastLogin"].toString()) : <any>null;
      this.createdBy = data["CreatedBy"] !== undefined ? data["CreatedBy"] : <any>null;
      this.modifiedBy = data["ModifiedBy"] !== undefined ? data["ModifiedBy"] : <any>null;
      this.role = data["Role"] !== undefined ? data["Role"] : <any>null;
      this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
      this.tenantVerifiedDomainName = data["TenantVerifiedDomainName"] !== undefined ? data["TenantVerifiedDomainName"] : <any>null;
      this.userName = data["UserName"] !== undefined ? data["UserName"] : <any>null;
      this.alertEmail = data["AlertEmail"] !== undefined ? data["AlertEmail"] : <any>null;
      this.canReceiveAlertEmail = data["CanReceiveAlertEmail"] !== undefined ? data["CanReceiveAlertEmail"] : <any>null;
      this.alertMobilePhone = data["AlertMobilePhone"] !== undefined ? data["AlertMobilePhone"] : <any>null;
      this.alertMobilePhoneCountryCode = data["AlertMobilePhoneCountryCode"] !== undefined ? data["AlertMobilePhoneCountryCode"] : <any>null;
      this.canReceiveAlertSMS = data["CanReceiveAlertSMS"] !== undefined ? data["CanReceiveAlertSMS"] : <any>null;
      this.showWhatsNew = data["ShowWhatsNew"] !== undefined ? data["ShowWhatsNew"] : <any>null;
      this.newFeatureAvailable = data["NewFeatureAvailable"] !== undefined ? data["NewFeatureAvailable"] : <any>null;
      this.dealerUser = data["DealerUser"] !== undefined ? data["DealerUser"] : <any>null;
      if (data["CustomerAccounts"] && data["CustomerAccounts"].constructor === Array) {
        this.customerAccounts = [];
        for (let item of data["CustomerAccounts"])
          this.customerAccounts.push(CustomerAccountAccess.fromJS(item));
      }
    }
  }

  static fromJS(data: any): HydrogenUser {
    let result = new HydrogenUser();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["FirstName"] = this.firstName !== undefined ? this.firstName : <any>null;
    data["MiddleName"] = this.middleName !== undefined ? this.middleName : <any>null;
    data["LastName"] = this.lastName !== undefined ? this.lastName : <any>null;
    data["Email"] = this.email !== undefined ? this.email : <any>null;
    data["UserType"] = this.userType !== undefined ? this.userType : <any>null;
    data["UserPhone"] = this.userPhone !== undefined ? this.userPhone : <any>null;
    data["IsActive"] = this.isActive !== undefined ? this.isActive : <any>null;
    data["IsDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
    data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>null;
    data["LastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>null;
    data["CreatedBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["ModifiedBy"] = this.modifiedBy !== undefined ? this.modifiedBy : <any>null;
    data["Role"] = this.role !== undefined ? this.role : <any>null;
    data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
    data["TenantVerifiedDomainName"] = this.tenantVerifiedDomainName !== undefined ? this.tenantVerifiedDomainName : <any>null;
    data["UserName"] = this.userName !== undefined ? this.userName : <any>null;
    data["AlertEmail"] = this.alertEmail !== undefined ? this.alertEmail : <any>null;
    data["CanReceiveAlertEmail"] = this.canReceiveAlertEmail !== undefined ? this.canReceiveAlertEmail : <any>null;
    data["AlertMobilePhone"] = this.alertMobilePhone !== undefined ? this.alertMobilePhone : <any>null;
    data["AlertMobilePhoneCountryCode"] = this.alertMobilePhoneCountryCode !== undefined ? this.alertMobilePhoneCountryCode : <any>null;
    data["CanReceiveAlertSMS"] = this.canReceiveAlertSMS !== undefined ? this.canReceiveAlertSMS : <any>null;
    data["ShowWhatsNew"] = this.showWhatsNew !== undefined ? this.showWhatsNew : <any>null;
    data["NewFeatureAvailable"] = this.newFeatureAvailable !== undefined ? this.newFeatureAvailable : <any>null;
    data["DealerUser"] = this.dealerUser !== undefined ? this.dealerUser : <any>null;
    if (this.customerAccounts && this.customerAccounts.constructor === Array) {
      data["CustomerAccounts"] = [];
      for (let item of this.customerAccounts)
        data["CustomerAccounts"].push(item.toJSON());
    }
    return data;
  }
}

export interface IHydrogenUser {
  id?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  userType: UserTypeEnum;
  userPhone?: string;
  isActive: boolean;
  isDeleted: boolean;
  createdOn: Date;
  modifiedOn: Date;
  lastLogin: Date;
  createdBy?: string;
  modifiedBy?: string;
  role?: string;
  accountId: string;
  tenantVerifiedDomainName?: string;
  userName?: string;
  alertEmail?: string;
  canReceiveAlertEmail?: boolean;
  alertMobilePhone?: string;
  alertMobilePhoneCountryCode?: string;
  canReceiveAlertSMS?: boolean;
  showWhatsNew?: boolean;
  newFeatureAvailable?: boolean;
  dealerUser?: boolean;
  customerAccounts?: CustomerAccountAccess[];
}

export enum UserTypeEnum {
  CRESTRON = 0,
  TENANT = 1,
}

export class CustomerAccountAccess implements ICustomerAccountAccess {
  customerAccountId: string;
  accessRole?: string;

  constructor(data?: ICustomerAccountAccess) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.customerAccountId = data["CustomerAccountId"] !== undefined ? data["CustomerAccountId"] : <any>null;
      this.accessRole = data["AccessRole"] !== undefined ? data["AccessRole"] : <any>null;
    }
  }

  static fromJS(data: any): CustomerAccountAccess {
    let result = new CustomerAccountAccess();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["CustomerAccountId"] = this.customerAccountId !== undefined ? this.customerAccountId : <any>null;
    data["AccessRole"] = this.accessRole !== undefined ? this.accessRole : <any>null;
    return data;
  }
}

export interface ICustomerAccountAccess {
  customerAccountId: string;
  accessRole?: string;
}

export class ActivityLog implements IActivityLog {
  id: string;
  accountId?: string;
  objectId?: string;
  objectName?: string;
  deviceModelType?: string;
  created: Date;
  correlationId: string;
  userId?: string;
  userName?: string;
  logType: ActivityLogType;
  targetObject?: string;
  property?: string;
  originalValue?: any;
  updatedValue?: any;
  actualValue?: any;
  displayedValue?: string;
  snapshottedObject?: any;

  constructor(data?: IActivityLog) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data["id"] !== undefined ? data["id"] : <any>null;
      this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
      this.objectId = data["ObjectId"] !== undefined ? data["ObjectId"] : <any>null;
      this.objectName = data["ObjectName"] !== undefined ? data["ObjectName"] : <any>null;
      this.deviceModelType = data["DeviceModelType"] !== undefined ? data["DeviceModelType"] : <any>null;
      this.created = data["Created"] ? new Date(data["Created"].toString()) : <any>null;
      this.correlationId = data["CorrelationId"] !== undefined ? data["CorrelationId"] : <any>null;
      this.userId = data["UserId"] !== undefined ? data["UserId"] : <any>null;
      this.userName = data["UserName"] !== undefined ? data["UserName"] : <any>null;
      this.logType = data["LogType"] !== undefined ? data["LogType"] : <any>null;
      this.targetObject = data["TargetObject"] !== undefined ? data["TargetObject"] : <any>null;
      this.property = data["Property"] !== undefined ? data["Property"] : <any>null;
      this.originalValue = data["OriginalValue"] !== undefined ? data["OriginalValue"] : <any>null;
      this.updatedValue = data["UpdatedValue"] !== undefined ? data["UpdatedValue"] : <any>null;
      this.actualValue = data["ActualValue"] !== undefined ? data["ActualValue"] : <any>null;
      this.displayedValue = data["DisplayedValue"] !== undefined ? data["DisplayedValue"] : <any>null;
      this.snapshottedObject = data["SnapshottedObject"] !== undefined ? data["SnapshottedObject"] : <any>null;
    }
  }

  static fromJS(data: any): ActivityLog {
    let result = new ActivityLog();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
    data["ObjectId"] = this.objectId !== undefined ? this.objectId : <any>null;
    data["ObjectName"] = this.objectName !== undefined ? this.objectName : <any>null;
    data["DeviceModelType"] = this.deviceModelType !== undefined ? this.deviceModelType : <any>null;
    data["Created"] = this.created ? this.created.toISOString() : <any>null;
    data["CorrelationId"] = this.correlationId !== undefined ? this.correlationId : <any>null;
    data["UserId"] = this.userId !== undefined ? this.userId : <any>null;
    data["UserName"] = this.userName !== undefined ? this.userName : <any>null;
    data["LogType"] = this.logType !== undefined ? this.logType : <any>null;
    data["TargetObject"] = this.targetObject !== undefined ? this.targetObject : <any>null;
    data["Property"] = this.property !== undefined ? this.property : <any>null;
    data["OriginalValue"] = this.originalValue !== undefined ? this.originalValue : <any>null;
    data["UpdatedValue"] = this.updatedValue !== undefined ? this.updatedValue : <any>null;
    data["ActualValue"] = this.actualValue !== undefined ? this.actualValue : <any>null;
    data["DisplayedValue"] = this.displayedValue !== undefined ? this.displayedValue : <any>null;
    data["SnapshottedObject"] = this.snapshottedObject !== undefined ? this.snapshottedObject : <any>null;
    return data;
  }
}

export interface IActivityLog {
  id: string;
  accountId?: string;
  objectId?: string;
  objectName?: string;
  deviceModelType?: string;
  created: Date;
  correlationId: string;
  userId?: string;
  userName?: string;
  logType: ActivityLogType;
  targetObject?: string;
  property?: string;
  originalValue?: any;
  updatedValue?: any;
  actualValue?: any;
  displayedValue?: string;
  snapshottedObject?: any;
}

export enum ActivityLogType {
  Device = 0,
  Group = 1,
  License = 2,
  Firmware = 3,
  Account = 4,
}

export class AccountAPIRequest implements IAccountAPIRequest {
  accountInfo?: Account;
  activitylogs?: ActivityLog[];
  dealerAccountIds?: string[];

  constructor(data?: IAccountAPIRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.accountInfo = data["AccountInfo"] ? Account.fromJS(data["AccountInfo"]) : <any>null;
      if (data["activitylogs"] && data["activitylogs"].constructor === Array) {
        this.activitylogs = [];
        for (let item of data["activitylogs"])
          this.activitylogs.push(ActivityLog.fromJS(item));
      }
      if (data["dealerAccountIds"] && data["dealerAccountIds"].constructor === Array) {
        this.dealerAccountIds = [];
        for (let item of data["dealerAccountIds"])
          this.dealerAccountIds.push(item);
      }
    }
  }

  static fromJS(data: any): AccountAPIRequest {
    let result = new AccountAPIRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["AccountInfo"] = this.accountInfo ? this.accountInfo.toJSON() : <any>null;
    if (this.activitylogs && this.activitylogs.constructor === Array) {
      data["activitylogs"] = [];
      for (let item of this.activitylogs)
        data["activitylogs"].push(item.toJSON());
    }
    if (this.dealerAccountIds && this.dealerAccountIds.constructor === Array) {
      data["dealerAccountIds"] = [];
      for (let item of this.dealerAccountIds)
        data["dealerAccountIds"].push(item);
    }
    return data;
  }
}

export interface IAccountAPIRequest {
  accountInfo?: Account;
  activitylogs?: ActivityLog[];
  dealerAccountIds?: string[];
}

export class AccountTable implements IAccountTable {
  indexedAccounts?: IndexedAccount[];
  totalRecords?: number;

  constructor(data?: IAccountTable) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (data["IndexedAccounts"] && data["IndexedAccounts"].constructor === Array) {
        this.indexedAccounts = [];
        for (let item of data["IndexedAccounts"])
          this.indexedAccounts.push(IndexedAccount.fromJS(item));
      }
      this.totalRecords = data["TotalRecords"] !== undefined ? data["TotalRecords"] : <any>null;
    }
  }

  static fromJS(data: any): AccountTable {
    let result = new AccountTable();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.indexedAccounts && this.indexedAccounts.constructor === Array) {
      data["IndexedAccounts"] = [];
      for (let item of this.indexedAccounts)
        data["IndexedAccounts"].push(item.toJSON());
    }
    data["TotalRecords"] = this.totalRecords !== undefined ? this.totalRecords : <any>null;
    return data;
  }
}

export interface IAccountTable {
  indexedAccounts?: IndexedAccount[];
  totalRecords?: number;
}

export class IndexedAccount implements IIndexedAccount {
  accountId?: string;
  accountNumber?: string;
  accountName?: string;
  email?: string;
  orderNumbers?: string[];
  dealers?: string[];
  deviceCount?: number;
  deviceAlotted?: number;
  deviceCountString?: string;
  tier?: string;
  expiration?: string;
  accountType?: string;

  constructor(data?: IIndexedAccount) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
      this.accountNumber = data["AccountNumber"] !== undefined ? data["AccountNumber"] : <any>null;
      this.accountName = data["AccountName"] !== undefined ? data["AccountName"] : <any>null;
      this.email = data["Email"] !== undefined ? data["Email"] : <any>null;
      if (data["OrderNumbers"] && data["OrderNumbers"].constructor === Array) {
        this.orderNumbers = [];
        for (let item of data["OrderNumbers"])
          this.orderNumbers.push(item);
      }
      if (data["Dealers"] && data["Dealers"].constructor === Array) {
        this.dealers = [];
        for (let item of data["Dealers"])
          this.dealers.push(item);
      }
      this.deviceCount = data["DeviceCount"] !== undefined ? data["DeviceCount"] : <any>null;
      this.deviceAlotted = data["DeviceAlotted"] !== undefined ? data["DeviceAlotted"] : <any>null;
      this.deviceCountString = data["DeviceCountString"] !== undefined ? data["DeviceCountString"] : <any>null;
      this.tier = data["Tier"] !== undefined ? data["Tier"] : <any>null;
      this.expiration = data["Expiration"] !== undefined ? data["Expiration"] : <any>null;
      this.accountType = data["AccountType"] !== undefined ? data["AccountType"] : <any>null;
    }
  }

  static fromJS(data: any): IndexedAccount {
    let result = new IndexedAccount();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
    data["AccountNumber"] = this.accountNumber !== undefined ? this.accountNumber : <any>null;
    data["AccountName"] = this.accountName !== undefined ? this.accountName : <any>null;
    data["Email"] = this.email !== undefined ? this.email : <any>null;
    if (this.orderNumbers && this.orderNumbers.constructor === Array) {
      data["OrderNumbers"] = [];
      for (let item of this.orderNumbers)
        data["OrderNumbers"].push(item);
    }
    if (this.dealers && this.dealers.constructor === Array) {
      data["Dealers"] = [];
      for (let item of this.dealers)
        data["Dealers"].push(item);
    }
    data["DeviceCount"] = this.deviceCount !== undefined ? this.deviceCount : <any>null;
    data["DeviceAlotted"] = this.deviceAlotted !== undefined ? this.deviceAlotted : <any>null;
    data["DeviceCountString"] = this.deviceCountString !== undefined ? this.deviceCountString : <any>null;
    data["Tier"] = this.tier !== undefined ? this.tier : <any>null;
    data["Expiration"] = this.expiration !== undefined ? this.expiration : <any>null;
    data["AccountType"] = this.accountType !== undefined ? this.accountType : <any>null;
    return data;
  }
}

export interface IIndexedAccount {
  accountId?: string;
  accountNumber?: string;
  accountName?: string;
  email?: string;
  orderNumbers?: string[];
  dealers?: string[];
  deviceCount?: number;
  deviceAlotted?: number;
  deviceCountString?: string;
  tier?: string;
  expiration?: string;
  accountType?: string;
}

export class UniversalDevicesData implements IUniversalDevicesData {
  devices?: UniversalDeviceInfo[];
  totalDevices: number;

  constructor(data?: IUniversalDevicesData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (data["Devices"] && data["Devices"].constructor === Array) {
        this.devices = [];
        for (let item of data["Devices"])
          this.devices.push(UniversalDeviceInfo.fromJS(item));
      }
      this.totalDevices = data["TotalDevices"] !== undefined ? data["TotalDevices"] : <any>null;
    }
  }

  static fromJS(data: any): UniversalDevicesData {
    let result = new UniversalDevicesData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.devices && this.devices.constructor === Array) {
      data["Devices"] = [];
      for (let item of this.devices)
        data["Devices"].push(item.toJSON());
    }
    data["TotalDevices"] = this.totalDevices !== undefined ? this.totalDevices : <any>null;
    return data;
  }
}

export interface IUniversalDevicesData {
  devices?: UniversalDeviceInfo[];
  totalDevices: number;
}

export class UniversalDeviceInfo implements IUniversalDeviceInfo {
  deviceId?: string;
  accountId?: string;
  accountName?: string;
  deviceMacAddress?: string;
  deviceSerialNumber?: string;
  deviceName?: string;
  deviceType?: string;
  lastConnected?: Date;

  constructor(data?: IUniversalDeviceInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.deviceId = data["DeviceId"] !== undefined ? data["DeviceId"] : <any>null;
      this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
      this.accountName = data["AccountName"] !== undefined ? data["AccountName"] : <any>null;
      this.deviceMacAddress = data["DeviceMacAddress"] !== undefined ? data["DeviceMacAddress"] : <any>null;
      this.deviceSerialNumber = data["DeviceSerialNumber"] !== undefined ? data["DeviceSerialNumber"] : <any>null;
      this.deviceName = data["DeviceName"] !== undefined ? data["DeviceName"] : <any>null;
      this.deviceType = data["DeviceType"] !== undefined ? data["DeviceType"] : <any>null;
      this.lastConnected = data["LastConnected"] ? new Date(data["LastConnected"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): UniversalDeviceInfo {
    let result = new UniversalDeviceInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["DeviceId"] = this.deviceId !== undefined ? this.deviceId : <any>null;
    data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
    data["AccountName"] = this.accountName !== undefined ? this.accountName : <any>null;
    data["DeviceMacAddress"] = this.deviceMacAddress !== undefined ? this.deviceMacAddress : <any>null;
    data["DeviceSerialNumber"] = this.deviceSerialNumber !== undefined ? this.deviceSerialNumber : <any>null;
    data["DeviceName"] = this.deviceName !== undefined ? this.deviceName : <any>null;
    data["DeviceType"] = this.deviceType !== undefined ? this.deviceType : <any>null;
    data["LastConnected"] = this.lastConnected ? this.lastConnected.toISOString() : <any>null;
    return data;
  }
}

export interface IUniversalDeviceInfo {
  deviceId?: string;
  accountId?: string;
  accountName?: string;
  deviceMacAddress?: string;
  deviceSerialNumber?: string;
  deviceName?: string;
  deviceType?: string;
  lastConnected?: Date;
}

export class ObjectVersion implements IObjectVersion {
  version?: string;

  constructor(data?: IObjectVersion) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.version = data["Version"] !== undefined ? data["Version"] : <any>null;
    }
  }

  static fromJS(data: any): ObjectVersion {
    let result = new ObjectVersion();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["Version"] = this.version !== undefined ? this.version : <any>null;
    return data;
  }
}

export interface IObjectVersion {
  version?: string;
}

export class DevicePropertyDocument extends ObjectVersion implements IDevicePropertyDocument {
  id?: string;
  cid?: string;
  propertyType?: string;
  eTag?: string;

  constructor(data?: IDevicePropertyDocument) {
    super(data);
  }

  init(data?: any) {
    super.init(data);
    if (data) {
      this.id = data["id"] !== undefined ? data["id"] : <any>null;
      this.cid = data["cid"] !== undefined ? data["cid"] : <any>null;
      this.propertyType = data["PropertyType"] !== undefined ? data["PropertyType"] : <any>null;
      this.eTag = data["ETag"] !== undefined ? data["ETag"] : <any>null;
    }
  }

  static fromJS(data: any): DevicePropertyDocument {
    let result = new DevicePropertyDocument();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["cid"] = this.cid !== undefined ? this.cid : <any>null;
    data["PropertyType"] = this.propertyType !== undefined ? this.propertyType : <any>null;
    data["ETag"] = this.eTag !== undefined ? this.eTag : <any>null;
    super.toJSON(data);
    return data;
  }
}

export interface IDevicePropertyDocument extends IObjectVersion {
  id?: string;
  cid?: string;
  propertyType?: string;
  eTag?: string;
}

export class DeviceList extends DevicePropertyDocument implements IDeviceList {
  documentType?: string;
  userDeviceName?: string;
  region?: string;
  connectedToIoTHub?: boolean;
  deviceInfo?: DeviceInfo;
  accountId?: string;
  groupId?: string;
  licenseIds?: string[];
  userPrincipalNames?: string[];
  tagIds?: string[];
  action?: MergeAction;
  ethernet?: Ethernet;
  created?: Date;
  lastModified?: Date;
  lastCommunicated?: Date;
  fCSPUFVersion?: string;
  scheduledActionsResult?: ScheduledActionsResult;

  constructor(data?: IDeviceList) {
    super(data);
  }

  init(data?: any) {
    super.init(data);
    if (data) {
      this.documentType = data["DocumentType"] !== undefined ? data["DocumentType"] : <any>null;
      this.userDeviceName = data["UserDeviceName"] !== undefined ? data["UserDeviceName"] : <any>null;
      this.region = data["Region"] !== undefined ? data["Region"] : <any>null;
      this.connectedToIoTHub = data["ConnectedToIoTHub"] !== undefined ? data["ConnectedToIoTHub"] : <any>null;
      this.deviceInfo = data["DeviceInfo"] ? DeviceInfo.fromJS(data["DeviceInfo"]) : <any>null;
      this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
      this.groupId = data["GroupId"] !== undefined ? data["GroupId"] : <any>null;
      if (data["LicenseIds"] && data["LicenseIds"].constructor === Array) {
        this.licenseIds = [];
        for (let item of data["LicenseIds"])
          this.licenseIds.push(item);
      }
      if (data["UserPrincipalNames"] && data["UserPrincipalNames"].constructor === Array) {
        this.userPrincipalNames = [];
        for (let item of data["UserPrincipalNames"])
          this.userPrincipalNames.push(item);
      }
      if (data["TagIds"] && data["TagIds"].constructor === Array) {
        this.tagIds = [];
        for (let item of data["TagIds"])
          this.tagIds.push(item);
      }
      this.action = data["Action"] ? MergeAction.fromJS(data["Action"]) : <any>null;
      this.ethernet = data["Ethernet"] ? Ethernet.fromJS(data["Ethernet"]) : <any>null;
      this.created = data["Created"] ? new Date(data["Created"].toString()) : <any>null;
      this.lastModified = data["LastModified"] ? new Date(data["LastModified"].toString()) : <any>null;
      this.lastCommunicated = data["LastCommunicated"] ? new Date(data["LastCommunicated"].toString()) : <any>null;
      this.fCSPUFVersion = data["FCSPUFVersion"] !== undefined ? data["FCSPUFVersion"] : <any>null;
      this.scheduledActionsResult = data["ScheduledActionsResult"] ? ScheduledActionsResult.fromJS(data["ScheduledActionsResult"]) : <any>null;
    }
  }

  static fromJS(data: any): DeviceList {
    let result = new DeviceList();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["DocumentType"] = this.documentType !== undefined ? this.documentType : <any>null;
    data["UserDeviceName"] = this.userDeviceName !== undefined ? this.userDeviceName : <any>null;
    data["Region"] = this.region !== undefined ? this.region : <any>null;
    data["ConnectedToIoTHub"] = this.connectedToIoTHub !== undefined ? this.connectedToIoTHub : <any>null;
    data["DeviceInfo"] = this.deviceInfo ? this.deviceInfo.toJSON() : <any>null;
    data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
    data["GroupId"] = this.groupId !== undefined ? this.groupId : <any>null;
    if (this.licenseIds && this.licenseIds.constructor === Array) {
      data["LicenseIds"] = [];
      for (let item of this.licenseIds)
        data["LicenseIds"].push(item);
    }
    if (this.userPrincipalNames && this.userPrincipalNames.constructor === Array) {
      data["UserPrincipalNames"] = [];
      for (let item of this.userPrincipalNames)
        data["UserPrincipalNames"].push(item);
    }
    if (this.tagIds && this.tagIds.constructor === Array) {
      data["TagIds"] = [];
      for (let item of this.tagIds)
        data["TagIds"].push(item);
    }
    data["Action"] = this.action ? this.action.toJSON() : <any>null;
    data["Ethernet"] = this.ethernet ? this.ethernet.toJSON() : <any>null;
    data["Created"] = this.created ? this.created.toISOString() : <any>null;
    data["LastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>null;
    data["LastCommunicated"] = this.lastCommunicated ? this.lastCommunicated.toISOString() : <any>null;
    data["FCSPUFVersion"] = this.fCSPUFVersion !== undefined ? this.fCSPUFVersion : <any>null;
    data["ScheduledActionsResult"] = this.scheduledActionsResult ? this.scheduledActionsResult.toJSON() : <any>null;
    super.toJSON(data);
    return data;
  }
}

export interface IDeviceList extends IDevicePropertyDocument {
  documentType?: string;
  userDeviceName?: string;
  region?: string;
  connectedToIoTHub?: boolean;
  deviceInfo?: DeviceInfo;
  accountId?: string;
  groupId?: string;
  licenseIds?: string[];
  userPrincipalNames?: string[];
  tagIds?: string[];
  action?: MergeAction;
  ethernet?: Ethernet;
  created?: Date;
  lastModified?: Date;
  lastCommunicated?: Date;
  fCSPUFVersion?: string;
  scheduledActionsResult?: ScheduledActionsResult;
}

export class DeviceInfo implements IDeviceInfo {
  model?: string;
  category?: string;
  manufacturer?: string;
  deviceId?: string;
  serialNumber?: string;
  name?: string;
  deviceVersion?: string;
  buildDate?: string;
  deviceKey?: string;

  constructor(data?: IDeviceInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.model = data["Model"] !== undefined ? data["Model"] : <any>null;
      this.category = data["Category"] !== undefined ? data["Category"] : <any>null;
      this.manufacturer = data["Manufacturer"] !== undefined ? data["Manufacturer"] : <any>null;
      this.deviceId = data["DeviceId"] !== undefined ? data["DeviceId"] : <any>null;
      this.serialNumber = data["SerialNumber"] !== undefined ? data["SerialNumber"] : <any>null;
      this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
      this.deviceVersion = data["DeviceVersion"] !== undefined ? data["DeviceVersion"] : <any>null;
      this.buildDate = data["BuildDate"] !== undefined ? data["BuildDate"] : <any>null;
      this.deviceKey = data["DeviceKey"] !== undefined ? data["DeviceKey"] : <any>null;
    }
  }

  static fromJS(data: any): DeviceInfo {
    let result = new DeviceInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["Model"] = this.model !== undefined ? this.model : <any>null;
    data["Category"] = this.category !== undefined ? this.category : <any>null;
    data["Manufacturer"] = this.manufacturer !== undefined ? this.manufacturer : <any>null;
    data["DeviceId"] = this.deviceId !== undefined ? this.deviceId : <any>null;
    data["SerialNumber"] = this.serialNumber !== undefined ? this.serialNumber : <any>null;
    data["Name"] = this.name !== undefined ? this.name : <any>null;
    data["DeviceVersion"] = this.deviceVersion !== undefined ? this.deviceVersion : <any>null;
    data["BuildDate"] = this.buildDate !== undefined ? this.buildDate : <any>null;
    data["DeviceKey"] = this.deviceKey !== undefined ? this.deviceKey : <any>null;
    return data;
  }
}

export interface IDeviceInfo {
  model?: string;
  category?: string;
  manufacturer?: string;
  deviceId?: string;
  serialNumber?: string;
  name?: string;
  deviceVersion?: string;
  buildDate?: string;
  deviceKey?: string;
}

export class MergeAction extends ObjectVersion implements IMergeAction {
  deliveryState?: DeliveryStateEnum;
  operations?: DeviceOperation[];
  message?: string;

  constructor(data?: IMergeAction) {
    super(data);
  }

  init(data?: any) {
    super.init(data);
    if (data) {
      this.deliveryState = data["DeliveryState"] !== undefined ? data["DeliveryState"] : <any>null;
      if (data["Operations"] && data["Operations"].constructor === Array) {
        this.operations = [];
        for (let item of data["Operations"])
          this.operations.push(DeviceOperation.fromJS(item));
      }
      this.message = data["Message"] !== undefined ? data["Message"] : <any>null;
    }
  }

  static fromJS(data: any): MergeAction {
    let result = new MergeAction();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["DeliveryState"] = this.deliveryState !== undefined ? this.deliveryState : <any>null;
    if (this.operations && this.operations.constructor === Array) {
      data["Operations"] = [];
      for (let item of this.operations)
        data["Operations"].push(item.toJSON());
    }
    data["Message"] = this.message !== undefined ? this.message : <any>null;
    super.toJSON(data);
    return data;
  }
}

export interface IMergeAction extends IObjectVersion {
  deliveryState?: DeliveryStateEnum;
  operations?: DeviceOperation[];
  message?: string;
}

export enum DeliveryStateEnum {
  NA = <any>"NA",
  Pending = <any>"Pending",
  Delivered = <any>"Delivered",
  OnHold = <any>"OnHold",
  Blocked = <any>"Blocked",
}

export class DeviceOperation implements IDeviceOperation {
  targetObject?: string;
  deliveryState?: DeliveryStateEnum;
  operation?: OperationEnum;
  results?: Result[];

  constructor(data?: IDeviceOperation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.targetObject = data["TargetObject"] !== undefined ? data["TargetObject"] : <any>null;
      this.deliveryState = data["DeliveryState"] !== undefined ? data["DeliveryState"] : <any>null;
      this.operation = data["Operation"] !== undefined ? data["Operation"] : <any>null;
      if (data["Results"] && data["Results"].constructor === Array) {
        this.results = [];
        for (let item of data["Results"])
          this.results.push(Result.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DeviceOperation {
    let result = new DeviceOperation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["TargetObject"] = this.targetObject !== undefined ? this.targetObject : <any>null;
    data["DeliveryState"] = this.deliveryState !== undefined ? this.deliveryState : <any>null;
    data["Operation"] = this.operation !== undefined ? this.operation : <any>null;
    if (this.results && this.results.constructor === Array) {
      data["Results"] = [];
      for (let item of this.results)
        data["Results"].push(item.toJSON());
    }
    return data;
  }
}

export interface IDeviceOperation {
  targetObject?: string;
  deliveryState?: DeliveryStateEnum;
  operation?: OperationEnum;
  results?: Result[];
}

export enum OperationEnum {
  NA = <any>"NA",
  SetPartial = <any>"SetPartial",
  SetFull = <any>"SetFull",
}

export class Result implements IResult {
  operationState?: OperationStateEnum;
  property?: string;
  path?: string;
  statusId?: number;
  statusInfo?: string;

  constructor(data?: IResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.operationState = data["OperationState"] !== undefined ? data["OperationState"] : <any>null;
      this.property = data["Property"] !== undefined ? data["Property"] : <any>null;
      this.path = data["Path"] !== undefined ? data["Path"] : <any>null;
      this.statusId = data["StatusId"] !== undefined ? data["StatusId"] : <any>null;
      this.statusInfo = data["StatusInfo"] !== undefined ? data["StatusInfo"] : <any>null;
    }
  }

  static fromJS(data: any): Result {
    let result = new Result();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["OperationState"] = this.operationState !== undefined ? this.operationState : <any>null;
    data["Property"] = this.property !== undefined ? this.property : <any>null;
    data["Path"] = this.path !== undefined ? this.path : <any>null;
    data["StatusId"] = this.statusId !== undefined ? this.statusId : <any>null;
    data["StatusInfo"] = this.statusInfo !== undefined ? this.statusInfo : <any>null;
    return data;
  }
}

export interface IResult {
  operationState?: OperationStateEnum;
  property?: string;
  path?: string;
  statusId?: number;
  statusInfo?: string;
}

export enum OperationStateEnum {
  NA = <any>"NA",
  Rejected = <any>"Rejected",
  Applied = <any>"Applied",
}

export class Ethernet_2_0_0 extends ObjectVersion implements IEthernet_2_0_0 {
  isEnabled?: boolean;
  autoNegotiationEnabled?: boolean;
  isIcmpPingEnabled?: boolean;
  isTcpKeepAliveEnabled?: boolean;
  hostName?: string;
  domainName?: string;
  encryptConnection?: boolean;
  adapters?: Adapter[];

  constructor(data?: IEthernet_2_0_0) {
    super(data);
  }

  init(data?: any) {
    super.init(data);
    if (data) {
      this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
      this.autoNegotiationEnabled = data["AutoNegotiationEnabled"] !== undefined ? data["AutoNegotiationEnabled"] : <any>null;
      this.isIcmpPingEnabled = data["IsIcmpPingEnabled"] !== undefined ? data["IsIcmpPingEnabled"] : <any>null;
      this.isTcpKeepAliveEnabled = data["IsTcpKeepAliveEnabled"] !== undefined ? data["IsTcpKeepAliveEnabled"] : <any>null;
      this.hostName = data["HostName"] !== undefined ? data["HostName"] : <any>null;
      this.domainName = data["DomainName"] !== undefined ? data["DomainName"] : <any>null;
      this.encryptConnection = data["EncryptConnection"] !== undefined ? data["EncryptConnection"] : <any>null;
      if (data["Adapters"] && data["Adapters"].constructor === Array) {
        this.adapters = [];
        for (let item of data["Adapters"])
          this.adapters.push(Adapter.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Ethernet_2_0_0 {
    let result = new Ethernet_2_0_0();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
    data["AutoNegotiationEnabled"] = this.autoNegotiationEnabled !== undefined ? this.autoNegotiationEnabled : <any>null;
    data["IsIcmpPingEnabled"] = this.isIcmpPingEnabled !== undefined ? this.isIcmpPingEnabled : <any>null;
    data["IsTcpKeepAliveEnabled"] = this.isTcpKeepAliveEnabled !== undefined ? this.isTcpKeepAliveEnabled : <any>null;
    data["HostName"] = this.hostName !== undefined ? this.hostName : <any>null;
    data["DomainName"] = this.domainName !== undefined ? this.domainName : <any>null;
    data["EncryptConnection"] = this.encryptConnection !== undefined ? this.encryptConnection : <any>null;
    if (this.adapters && this.adapters.constructor === Array) {
      data["Adapters"] = [];
      for (let item of this.adapters)
        data["Adapters"].push(item.toJSON());
    }
    super.toJSON(data);
    return data;
  }
}

export interface IEthernet_2_0_0 extends IObjectVersion {
  isEnabled?: boolean;
  autoNegotiationEnabled?: boolean;
  isIcmpPingEnabled?: boolean;
  isTcpKeepAliveEnabled?: boolean;
  hostName?: string;
  domainName?: string;
  encryptConnection?: boolean;
  adapters?: Adapter[];
}

export class Ethernet_2_0_1 extends Ethernet_2_0_0 implements IEthernet_2_0_1 {
  isSshEnabled?: boolean;

  constructor(data?: IEthernet_2_0_1) {
    super(data);
  }

  init(data?: any) {
    super.init(data);
    if (data) {
      this.isSshEnabled = data["IsSshEnabled"] !== undefined ? data["IsSshEnabled"] : <any>null;
    }
  }

  static fromJS(data: any): Ethernet_2_0_1 {
    let result = new Ethernet_2_0_1();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["IsSshEnabled"] = this.isSshEnabled !== undefined ? this.isSshEnabled : <any>null;
    super.toJSON(data);
    return data;
  }
}

export interface IEthernet_2_0_1 extends IEthernet_2_0_0 {
  isSshEnabled?: boolean;
}

export class Ethernet_2_0_2 extends Ethernet_2_0_1 implements IEthernet_2_0_2 {
  igmpVersion?: string;

  constructor(data?: IEthernet_2_0_2) {
    super(data);
  }

  init(data?: any) {
    super.init(data);
    if (data) {
      this.igmpVersion = data["IgmpVersion"] !== undefined ? data["IgmpVersion"] : <any>null;
    }
  }

  static fromJS(data: any): Ethernet_2_0_2 {
    let result = new Ethernet_2_0_2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["IgmpVersion"] = this.igmpVersion !== undefined ? this.igmpVersion : <any>null;
    super.toJSON(data);
    return data;
  }
}

export interface IEthernet_2_0_2 extends IEthernet_2_0_1 {
  igmpVersion?: string;
}

export class Ethernet_2_0_3 extends Ethernet_2_0_2 implements IEthernet_2_0_3 {

  constructor(data?: IEthernet_2_0_3) {
    super(data);
  }

  init(data?: any) {
    super.init(data);
    if (data) {
    }
  }

  static fromJS(data: any): Ethernet_2_0_3 {
    let result = new Ethernet_2_0_3();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IEthernet_2_0_3 extends IEthernet_2_0_2 {
}

export class Ethernet extends Ethernet_2_0_3 implements IEthernet {

  constructor(data?: IEthernet) {
    super(data);
  }

  init(data?: any) {
    super.init(data);
    if (data) {
    }
  }

  static fromJS(data: any): Ethernet {
    let result = new Ethernet();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IEthernet extends IEthernet_2_0_3 {
}

export class Adapter implements IAdapter {
  name?: string;
  mACAddress?: string;
  addressSchema?: string;
  isAdapterEnabled?: boolean;
  linkStatus?: boolean;
  portAssignments?: PortAssigment[];
  iPv4?: IPAddr;
  iPv6?: IPAddr;

  constructor(data?: IAdapter) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
      this.mACAddress = data["MACAddress"] !== undefined ? data["MACAddress"] : <any>null;
      this.addressSchema = data["AddressSchema"] !== undefined ? data["AddressSchema"] : <any>null;
      this.isAdapterEnabled = data["IsAdapterEnabled"] !== undefined ? data["IsAdapterEnabled"] : <any>null;
      this.linkStatus = data["LinkStatus"] !== undefined ? data["LinkStatus"] : <any>null;
      if (data["PortAssignments"] && data["PortAssignments"].constructor === Array) {
        this.portAssignments = [];
        for (let item of data["PortAssignments"])
          this.portAssignments.push(PortAssigment.fromJS(item));
      }
      this.iPv4 = data["IPv4"] ? IPAddr.fromJS(data["IPv4"]) : <any>null;
      this.iPv6 = data["IPv6"] ? IPAddr.fromJS(data["IPv6"]) : <any>null;
    }
  }

  static fromJS(data: any): Adapter {
    let result = new Adapter();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["Name"] = this.name !== undefined ? this.name : <any>null;
    data["MACAddress"] = this.mACAddress !== undefined ? this.mACAddress : <any>null;
    data["AddressSchema"] = this.addressSchema !== undefined ? this.addressSchema : <any>null;
    data["IsAdapterEnabled"] = this.isAdapterEnabled !== undefined ? this.isAdapterEnabled : <any>null;
    data["LinkStatus"] = this.linkStatus !== undefined ? this.linkStatus : <any>null;
    if (this.portAssignments && this.portAssignments.constructor === Array) {
      data["PortAssignments"] = [];
      for (let item of this.portAssignments)
        data["PortAssignments"].push(item.toJSON());
    }
    data["IPv4"] = this.iPv4 ? this.iPv4.toJSON() : <any>null;
    data["IPv6"] = this.iPv6 ? this.iPv6.toJSON() : <any>null;
    return data;
  }
}

export interface IAdapter {
  name?: string;
  mACAddress?: string;
  addressSchema?: string;
  isAdapterEnabled?: boolean;
  linkStatus?: boolean;
  portAssignments?: PortAssigment[];
  iPv4?: IPAddr;
  iPv6?: IPAddr;
}

export class PortAssigment implements IPortAssigment {
  name?: string;
  isEnabled?: boolean;
  portNumbers?: number[];

  constructor(data?: IPortAssigment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
      this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
      if (data["PortNumbers"] && data["PortNumbers"].constructor === Array) {
        this.portNumbers = [];
        for (let item of data["PortNumbers"])
          this.portNumbers.push(item);
      }
    }
  }

  static fromJS(data: any): PortAssigment {
    let result = new PortAssigment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["Name"] = this.name !== undefined ? this.name : <any>null;
    data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
    if (this.portNumbers && this.portNumbers.constructor === Array) {
      data["PortNumbers"] = [];
      for (let item of this.portNumbers)
        data["PortNumbers"].push(item);
    }
    return data;
  }
}

export interface IPortAssigment {
  name?: string;
  isEnabled?: boolean;
  portNumbers?: number[];
}

export class IPAddr implements IIPAddr {
  addresses?: Addresses[];
  staticAddresses?: Addresses[];
  staticDefaultGateway?: string;
  defaultGateway?: string;
  dnsServers?: string[];
  staticDns?: string[];
  isDhcpEnabled?: boolean;

  constructor(data?: IIPAddr) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (data["Addresses"] && data["Addresses"].constructor === Array) {
        this.addresses = [];
        for (let item of data["Addresses"])
          this.addresses.push(Addresses.fromJS(item));
      }
      if (data["StaticAddresses"] && data["StaticAddresses"].constructor === Array) {
        this.staticAddresses = [];
        for (let item of data["StaticAddresses"])
          this.staticAddresses.push(Addresses.fromJS(item));
      }
      this.staticDefaultGateway = data["StaticDefaultGateway"] !== undefined ? data["StaticDefaultGateway"] : <any>null;
      this.defaultGateway = data["DefaultGateway"] !== undefined ? data["DefaultGateway"] : <any>null;
      if (data["DnsServers"] && data["DnsServers"].constructor === Array) {
        this.dnsServers = [];
        for (let item of data["DnsServers"])
          this.dnsServers.push(item);
      }
      if (data["StaticDns"] && data["StaticDns"].constructor === Array) {
        this.staticDns = [];
        for (let item of data["StaticDns"])
          this.staticDns.push(item);
      }
      this.isDhcpEnabled = data["IsDhcpEnabled"] !== undefined ? data["IsDhcpEnabled"] : <any>null;
    }
  }

  static fromJS(data: any): IPAddr {
    let result = new IPAddr();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.addresses && this.addresses.constructor === Array) {
      data["Addresses"] = [];
      for (let item of this.addresses)
        data["Addresses"].push(item.toJSON());
    }
    if (this.staticAddresses && this.staticAddresses.constructor === Array) {
      data["StaticAddresses"] = [];
      for (let item of this.staticAddresses)
        data["StaticAddresses"].push(item.toJSON());
    }
    data["StaticDefaultGateway"] = this.staticDefaultGateway !== undefined ? this.staticDefaultGateway : <any>null;
    data["DefaultGateway"] = this.defaultGateway !== undefined ? this.defaultGateway : <any>null;
    if (this.dnsServers && this.dnsServers.constructor === Array) {
      data["DnsServers"] = [];
      for (let item of this.dnsServers)
        data["DnsServers"].push(item);
    }
    if (this.staticDns && this.staticDns.constructor === Array) {
      data["StaticDns"] = [];
      for (let item of this.staticDns)
        data["StaticDns"].push(item);
    }
    data["IsDhcpEnabled"] = this.isDhcpEnabled !== undefined ? this.isDhcpEnabled : <any>null;
    return data;
  }
}

export interface IIPAddr {
  addresses?: Addresses[];
  staticAddresses?: Addresses[];
  staticDefaultGateway?: string;
  defaultGateway?: string;
  dnsServers?: string[];
  staticDns?: string[];
  isDhcpEnabled?: boolean;
}

export class Addresses implements IAddresses {
  address?: string;
  subnetMask?: string;

  constructor(data?: IAddresses) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.address = data["Address"] !== undefined ? data["Address"] : <any>null;
      this.subnetMask = data["SubnetMask"] !== undefined ? data["SubnetMask"] : <any>null;
    }
  }

  static fromJS(data: any): Addresses {
    let result = new Addresses();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["Address"] = this.address !== undefined ? this.address : <any>null;
    data["SubnetMask"] = this.subnetMask !== undefined ? this.subnetMask : <any>null;
    return data;
  }
}

export interface IAddresses {
  address?: string;
  subnetMask?: string;
}

export class ScheduledActionsResult implements IScheduledActionsResult {
  result?: { [key: string]: ActionsStatus; };

  constructor(data?: IScheduledActionsResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (data["Result"]) {
        this.result = {};
        for (let key in data["Result"]) {
          if (data["Result"].hasOwnProperty(key))
            this.result[key] = data["Result"][key] ? ActionsStatus.fromJS(data["Result"][key]) : new ActionsStatus();
        }
      }
    }
  }

  static fromJS(data: any): ScheduledActionsResult {
    let result = new ScheduledActionsResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.result) {
      data["Result"] = {};
      for (let key in this.result) {
        if (this.result.hasOwnProperty(key))
          data["Result"][key] = this.result[key] ? this.result[key].toJSON() : <any>null;
      }
    }
    return data;
  }
}

export interface IScheduledActionsResult {
  result?: { [key: string]: ActionsStatus; };
}

export class ActionsStatus implements IActionsStatus {
  lastRunTime?: Date;
  isSuccessful: boolean;

  constructor(data?: IActionsStatus) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.lastRunTime = data["LastRunTime"] ? new Date(data["LastRunTime"].toString()) : <any>null;
      this.isSuccessful = data["IsSuccessful"] !== undefined ? data["IsSuccessful"] : <any>null;
    }
  }

  static fromJS(data: any): ActionsStatus {
    let result = new ActionsStatus();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["LastRunTime"] = this.lastRunTime ? this.lastRunTime.toISOString() : <any>null;
    data["IsSuccessful"] = this.isSuccessful !== undefined ? this.isSuccessful : <any>null;
    return data;
  }
}

export interface IActionsStatus {
  lastRunTime?: Date;
  isSuccessful: boolean;
}

export class ReportUnownedDevicesData implements IReportUnownedDevicesData {
  totalDevices: number;
  devices?: DeviceList[];

  constructor(data?: IReportUnownedDevicesData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalDevices = data["totalDevices"] !== undefined ? data["totalDevices"] : <any>null;
      if (data["devices"] && data["devices"].constructor === Array) {
        this.devices = [];
        for (let item of data["devices"])
          this.devices.push(DeviceList.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ReportUnownedDevicesData {
    let result = new ReportUnownedDevicesData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalDevices"] = this.totalDevices !== undefined ? this.totalDevices : <any>null;
    if (this.devices && this.devices.constructor === Array) {
      data["devices"] = [];
      for (let item of this.devices)
        data["devices"].push(item.toJSON());
    }
    return data;
  }
}

export interface IReportUnownedDevicesData {
  totalDevices: number;
  devices?: DeviceList[];
}

export class AccountDetail extends Account implements IAccountDetail {
  dealerInfo?: Dealer[];
  usersCount?: number;
  deviceCount?: number;
  userLastLogin?: Date;
  isExpired: boolean;

  constructor(data?: IAccountDetail) {
    super(data);
  }

  init(data?: any) {
    super.init(data);
    if (data) {
      if (data["DealerInfo"] && data["DealerInfo"].constructor === Array) {
        this.dealerInfo = [];
        for (let item of data["DealerInfo"])
          this.dealerInfo.push(Dealer.fromJS(item));
      }
      this.usersCount = data["UsersCount"] !== undefined ? data["UsersCount"] : <any>null;
      this.deviceCount = data["DeviceCount"] !== undefined ? data["DeviceCount"] : <any>null;
      this.userLastLogin = data["UserLastLogin"] ? new Date(data["UserLastLogin"].toString()) : <any>null;
      this.isExpired = data["IsExpired"] !== undefined ? data["IsExpired"] : <any>null;
    }
  }

  static fromJS(data: any): AccountDetail {
    let result = new AccountDetail();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.dealerInfo && this.dealerInfo.constructor === Array) {
      data["DealerInfo"] = [];
      for (let item of this.dealerInfo)
        data["DealerInfo"].push(item.toJSON());
    }
    data["UsersCount"] = this.usersCount !== undefined ? this.usersCount : <any>null;
    data["DeviceCount"] = this.deviceCount !== undefined ? this.deviceCount : <any>null;
    data["UserLastLogin"] = this.userLastLogin ? this.userLastLogin.toISOString() : <any>null;
    data["IsExpired"] = this.isExpired !== undefined ? this.isExpired : <any>null;
    super.toJSON(data);
    return data;
  }
}

export interface IAccountDetail extends IAccount {
  dealerInfo?: Dealer[];
  usersCount?: number;
  deviceCount?: number;
  userLastLogin?: Date;
  isExpired: boolean;
}

export class Dealer implements IDealer {
  id?: string;
  name?: string;

  constructor(data?: IDealer) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data["id"] !== undefined ? data["id"] : <any>null;
      this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
    }
  }

  static fromJS(data: any): Dealer {
    let result = new Dealer();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["Name"] = this.name !== undefined ? this.name : <any>null;
    return data;
  }
}

export interface IDealer {
  id?: string;
  name?: string;
}

export class IndexedAccountLogsData implements IIndexedAccountLogsData {
  accountLogs?: IndexedAccountLogInfo[];
  totalAccountLogs: number;

  constructor(data?: IIndexedAccountLogsData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (data["AccountLogs"] && data["AccountLogs"].constructor === Array) {
        this.accountLogs = [];
        for (let item of data["AccountLogs"])
          this.accountLogs.push(IndexedAccountLogInfo.fromJS(item));
      }
      this.totalAccountLogs = data["TotalAccountLogs"] !== undefined ? data["TotalAccountLogs"] : <any>null;
    }
  }

  static fromJS(data: any): IndexedAccountLogsData {
    let result = new IndexedAccountLogsData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.accountLogs && this.accountLogs.constructor === Array) {
      data["AccountLogs"] = [];
      for (let item of this.accountLogs)
        data["AccountLogs"].push(item.toJSON());
    }
    data["TotalAccountLogs"] = this.totalAccountLogs !== undefined ? this.totalAccountLogs : <any>null;
    return data;
  }
}

export interface IIndexedAccountLogsData {
  accountLogs?: IndexedAccountLogInfo[];
  totalAccountLogs: number;
}

export class IndexedAccountLogInfo implements IIndexedAccountLogInfo {
  id?: string;
  accountId?: string;
  userId?: string;
  userName?: string;
  accountName?: string;
  accountNumber?: string;
  devices?: string;
  tier?: string;
  orderNumber?: string;
  dealerNames?: string;
  expirationDate?: string;
  note?: string;
  timeStamp?: Date;

  constructor(data?: IIndexedAccountLogInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data["Id"] !== undefined ? data["Id"] : <any>null;
      this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
      this.userId = data["UserId"] !== undefined ? data["UserId"] : <any>null;
      this.userName = data["UserName"] !== undefined ? data["UserName"] : <any>null;
      this.accountName = data["AccountName"] !== undefined ? data["AccountName"] : <any>null;
      this.accountNumber = data["AccountNumber"] !== undefined ? data["AccountNumber"] : <any>null;
      this.devices = data["Devices"] !== undefined ? data["Devices"] : <any>null;
      this.tier = data["Tier"] !== undefined ? data["Tier"] : <any>null;
      this.orderNumber = data["OrderNumber"] !== undefined ? data["OrderNumber"] : <any>null;
      this.dealerNames = data["DealerNames"] !== undefined ? data["DealerNames"] : <any>null;
      this.expirationDate = data["ExpirationDate"] !== undefined ? data["ExpirationDate"] : <any>null;
      this.note = data["Note"] !== undefined ? data["Note"] : <any>null;
      this.timeStamp = data["TimeStamp"] ? new Date(data["TimeStamp"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): IndexedAccountLogInfo {
    let result = new IndexedAccountLogInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["Id"] = this.id !== undefined ? this.id : <any>null;
    data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
    data["UserId"] = this.userId !== undefined ? this.userId : <any>null;
    data["UserName"] = this.userName !== undefined ? this.userName : <any>null;
    data["AccountName"] = this.accountName !== undefined ? this.accountName : <any>null;
    data["AccountNumber"] = this.accountNumber !== undefined ? this.accountNumber : <any>null;
    data["Devices"] = this.devices !== undefined ? this.devices : <any>null;
    data["Tier"] = this.tier !== undefined ? this.tier : <any>null;
    data["OrderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
    data["DealerNames"] = this.dealerNames !== undefined ? this.dealerNames : <any>null;
    data["ExpirationDate"] = this.expirationDate !== undefined ? this.expirationDate : <any>null;
    data["Note"] = this.note !== undefined ? this.note : <any>null;
    data["TimeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
    return data;
  }
}

export interface IIndexedAccountLogInfo {
  id?: string;
  accountId?: string;
  userId?: string;
  userName?: string;
  accountName?: string;
  accountNumber?: string;
  devices?: string;
  tier?: string;
  orderNumber?: string;
  dealerNames?: string;
  expirationDate?: string;
  note?: string;
  timeStamp?: Date;
}

export class Feature implements IFeature {
  id?: string;
  name?: string;
  type?: string;
  parentId?: string;
  tiers?: { [key: string]: Access; };
  rBAC?: { [key: string]: Access; };

  constructor(data?: IFeature) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data["id"] !== undefined ? data["id"] : <any>null;
      this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
      this.type = data["Type"] !== undefined ? data["Type"] : <any>null;
      this.parentId = data["ParentId"] !== undefined ? data["ParentId"] : <any>null;
      if (data["Tiers"]) {
        this.tiers = {};
        for (let key in data["Tiers"]) {
          if (data["Tiers"].hasOwnProperty(key))
            this.tiers[key] = data["Tiers"][key] ? Access.fromJS(data["Tiers"][key]) : new Access();
        }
      }
      if (data["RBAC"]) {
        this.rBAC = {};
        for (let key in data["RBAC"]) {
          if (data["RBAC"].hasOwnProperty(key))
            this.rBAC[key] = data["RBAC"][key] ? Access.fromJS(data["RBAC"][key]) : new Access();
        }
      }
    }
  }

  static fromJS(data: any): Feature {
    let result = new Feature();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["Name"] = this.name !== undefined ? this.name : <any>null;
    data["Type"] = this.type !== undefined ? this.type : <any>null;
    data["ParentId"] = this.parentId !== undefined ? this.parentId : <any>null;
    if (this.tiers) {
      data["Tiers"] = {};
      for (let key in this.tiers) {
        if (this.tiers.hasOwnProperty(key))
          data["Tiers"][key] = this.tiers[key] ? this.tiers[key].toJSON() : <any>null;
      }
    }
    if (this.rBAC) {
      data["RBAC"] = {};
      for (let key in this.rBAC) {
        if (this.rBAC.hasOwnProperty(key))
          data["RBAC"][key] = this.rBAC[key] ? this.rBAC[key].toJSON() : <any>null;
      }
    }
    return data;
  }
}

export interface IFeature {
  id?: string;
  name?: string;
  type?: string;
  parentId?: string;
  tiers?: { [key: string]: Access; };
  rBAC?: { [key: string]: Access; };
}

export class Access implements IAccess {
  isVisible: boolean;
  isEnable: boolean;
  isExecute?: boolean;

  constructor(data?: IAccess) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.isVisible = data["IsVisible"] !== undefined ? data["IsVisible"] : <any>null;
      this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : <any>null;
      this.isExecute = data["IsExecute"] !== undefined ? data["IsExecute"] : <any>null;
    }
  }

  static fromJS(data: any): Access {
    let result = new Access();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["IsVisible"] = this.isVisible !== undefined ? this.isVisible : <any>null;
    data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : <any>null;
    data["IsExecute"] = this.isExecute !== undefined ? this.isExecute : <any>null;
    return data;
  }
}

export interface IAccess {
  isVisible: boolean;
  isEnable: boolean;
  isExecute?: boolean;
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return Observable.throw(result);
  else
    return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    let reader = new FileReader();
    reader.onload = function () {
      observer.next(this.result);
      observer.complete();
    }
    reader.readAsText(blob);
  });
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/Crestron.HydrogenAPI.AccountApi.service.ts